<div class="home">
    <h1>No Access</h1>
    <p>
        <b>We apologize for the inconvenience, but you do not have access to this page.</b>
    </p>
    <p>
        It is possible this is a problem that will be resolved in a few minutes, so please try again soon. If you continue to see this message, please contact us at <a href='mailto:support@greengopher.ai'>support"&#64;greengopher.ai</a> for assistance if you continue to see this error.
    </p>
</div>